import base from "./base"

export default (store, credentials) => {
  return base(store, {
    data: { credentials },
    methods: {
      refresh() {
        this.populate()
      },
      open_files: store.open,
      open_folders: store.open,
    },
  })
}
